module.exports = __webpack_public_path__ + "static/e-illu-2-cce63f39f4434ec68bb8f76f256fa618.png";